import { GaleriaVehiculoComponent } from './../galeria-vehiculo/galeria-vehiculo.component';
import { HistorialVelocidadesVehiculoComponent } from './../historial-velocidades-vehiculo/historial-velocidades-vehiculo.component';
import { PasoPuntoVehiculoComponent } from './../paso-punto-vehiculo/paso-punto-vehiculo.component';
import { HistoricoPosicionesVehiculoComponent } from './../historico-posiciones-vehiculo/historico-posiciones-vehiculo.component';
import { Permiso } from './../../../../../../_entities/Enums/permiso.enum';
import { DatePipe } from '@angular/common';
import { MapaService } from './../../../../services/mapa.service';
import { Autos } from './../../../../../../_entities/autos/Autos';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material';
import { Component, Inject, OnInit } from '@angular/core';
import { StreetViewComponent } from '../../street-view/street-view.component';
import { GaleriaVideosComponent } from '../galeria-videos/galeria-videos.component';
import { DentroGeocercaComponent } from '../dentro-geocerca/dentro-geocerca.component';
import { FueraGeocercaComponent } from '../fuera-geocerca/fuera-geocerca.component';
import { GaleriaNuevoDispositivoComponent } from '../galeria-nuevo-dispositivo/galeria-nuevo-dispositivo.component';
import { ModalImagenComponent } from '../../../../../mantenimiento/components/modal-imagen/modal-imagen.component';
import { PerfiloperadorComponent } from '../perfiloperador/perfiloperador.component';
import { HistoricoCombustibleComponent } from '../historico-combustible/historico-combustible.component';

@Component({
	selector: 'kt-informacion-vehiculo',
	templateUrl: './informacion-vehiculo.component.html',
	styleUrls: ['./informacion-vehiculo.component.scss']
})
export class InformacionVehiculoComponent implements OnInit {
	public permisoUbicarAutoModal: string;
	public permisoHistoricoAutoModal: string;
	public permisoStreetViewAutoModal: string;
	public permisoPasoPorPuntoAutoModal: string;
	public permisoMensajesAutoModal: string;
	public permisoGraficaAutoModal: string
	public permisoGaleriaAutoModal: string;
	public permisoVisualizarVideos: string;

	public datos: Autos;
	public direccion = "";
	public ignicion = "";
	public fecha = "";
	public hora = "";
	public idCliente;
	public geocercaAsignada: string = '';
	constructor(private mapaService: MapaService,
		public datePipe: DatePipe,
		public dialog: MatDialog,
		public dialogRef: MatDialogRef<InformacionVehiculoComponent>,
		@Inject(MAT_DIALOG_DATA) public data: Autos) { }

	ngOnInit() {
		this.obtenerPermisosAutoModal();
		this.obtenerDatosVehiculo(this.data);
	}

	async obtenerDatosVehiculo(datos) {
		this.datos = datos;
		this.idCliente = this.datos.idCliente;
		console.log(this.datos)
		if (this.data.ignicion === 0) {
			this.ignicion = "Apagado"
		} else if (this.data.ignicion === 1) {
			this.ignicion = "Encendido"
		}

		if (this.data.geocercas !== null) {
			if (this.data.geocercas.length > 0) {
				datos.geocercas.forEach(geocerca => {
					this.geocercaAsignada = this.geocercaAsignada + geocerca.nombre + ', ';
				});

				this.geocercaAsignada = this.geocercaAsignada.slice(0, -1);
				this.geocercaAsignada = this.geocercaAsignada.slice(0, -1);

			} else {
				this.geocercaAsignada = 'Sin asignación';
			}

		} else {
			this.geocercaAsignada = 'Sin asignación'
		}

		this.fecha = this.datePipe.transform(this.data.fechaHoraUltimaPosicion, "yyyy-MM-dd");
		this.hora = this.datePipe.transform(this.data.fechaHoraUltimaPosicion, "h:mma");

		await this.mapaService.getDireccion([this.data.lng, this.data.lat]).then(
			(data: any) => {
				this.direccion = data.display_name || "Dirección Desconocida";
			},
			() => {
				this.direccion = "Dirección Desconocida";
			}
		);

	}



	verHistorico() {
		this.dialogRef.close();
		/*Historico Popup*/
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.disableClose = true;
		dialogConfig.width = "50%";
		dialogConfig.panelClass = 'custom-modalbox';
		dialogConfig.closeOnNavigation = true;
		dialogConfig.hasBackdrop = false;
		dialogConfig.data = this.data
		this.dialog.open(HistoricoPosicionesVehiculoComponent, dialogConfig);
	}

	verStreet() {
		/*StreetView Popup*/
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.disableClose = true;
		dialogConfig.panelClass = 'custom-modalbox';
		dialogConfig.width = "45%";
		dialogConfig.closeOnNavigation = true;
		dialogConfig.hasBackdrop = false;
		dialogConfig.data = this.data;
		this.dialog.open(StreetViewComponent, dialogConfig);
	}

	verMensajes() {
		/*Mensajes*/
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.disableClose = true;
		dialogConfig.width = "50%";
		dialogConfig.panelClass = 'custom-modalbox';
		dialogConfig.closeOnNavigation = true;
		dialogConfig.hasBackdrop = false;
		dialogConfig.data = this.data
		//this.dialog.open(MensajesComponent, dialogConfig);
	}

	pasoPorPunto() {
		/*Paso por punto*/
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.disableClose = true;
		dialogConfig.width = "50%";
		dialogConfig.panelClass = 'custom-modalbox';
		dialogConfig.closeOnNavigation = true;
		dialogConfig.hasBackdrop = false;
		dialogConfig.data = this.data
		this.dialog.open(PasoPuntoVehiculoComponent, dialogConfig);
	}

	dentroGeocerca() {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.disableClose = true;
		dialogConfig.width = "50%";
		dialogConfig.panelClass = 'custom-modalbox';
		dialogConfig.closeOnNavigation = true;
		dialogConfig.hasBackdrop = false;
		dialogConfig.data = this.data
		this.dialog.open(DentroGeocercaComponent, dialogConfig);
	}

	fueraGeocerca() {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.disableClose = true;
		dialogConfig.width = "50%";
		dialogConfig.panelClass = 'custom-modalbox';
		dialogConfig.closeOnNavigation = true;
		dialogConfig.hasBackdrop = false;
		dialogConfig.data = this.data
		this.dialog.open(FueraGeocercaComponent, dialogConfig);
	}


	/***ver Gráfica  de velocidad*/
	verGrafica() {
		/*Paso por punto*/
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.disableClose = true;
		dialogConfig.width = "50%";
		dialogConfig.closeOnNavigation = true;
		dialogConfig.hasBackdrop = false;
		dialogConfig.panelClass = 'custom-modalbox';
		dialogConfig.data = this.data
		this.dialog.open(HistorialVelocidadesVehiculoComponent, dialogConfig);
	}

	
	/***ver Gráfica  de combustible*/
	verGraficaCombustible() {
		/*Paso por punto*/
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.disableClose = true;
		dialogConfig.width = "57%";
		dialogConfig.closeOnNavigation = true;
		dialogConfig.hasBackdrop = false;
		dialogConfig.panelClass = 'custom-modalbox';
		dialogConfig.data = this.data
		this.dialog.open(HistoricoCombustibleComponent, dialogConfig);
	}


	/**ver fotos */
	verFoto(imeiFk) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.disableClose = true;
		dialogConfig.width = "50%";
		dialogConfig.closeOnNavigation = true;
		dialogConfig.hasBackdrop = false;
		dialogConfig.panelClass = 'custom-modalbox';
		dialogConfig.data = imeiFk
		this.dialog.open(GaleriaVehiculoComponent, dialogConfig);
	}

		/**ver fotos */
		verFotoNuevoDispositivo(imeiFk) {
			const dialogConfig = new MatDialogConfig();
			dialogConfig.autoFocus = true;
			dialogConfig.disableClose = true;
			dialogConfig.width = "50%";
			dialogConfig.closeOnNavigation = true;
			dialogConfig.hasBackdrop = false;
			dialogConfig.panelClass = 'custom-modalbox';
			dialogConfig.data = imeiFk
			this.dialog.open(GaleriaNuevoDispositivoComponent, dialogConfig);
		}




	galeriaVideos(imeiFk) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.disableClose = true;
		dialogConfig.width = "50%";
		dialogConfig.closeOnNavigation = true;
		dialogConfig.hasBackdrop = false;
		dialogConfig.panelClass = 'custom-modalbox';
		dialogConfig.data = imeiFk
		this.dialog.open(GaleriaVideosComponent, dialogConfig);
	}

	ubicarVehiculo() {
		this.mapaService.verVehiculo(this.data);
	}

	public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	public cerrarPopup() {
		this.dialogRef.close();
	}

	obtenerPermisosAutoModal() {
		//this.permisoUbicar = Permiso.
		//this.permisoHistorico = Permiso.
		//this.permisoStreetView = Permiso.street
		//this.permisoPasoPorPunto = Permiso.punto
		this.permisoMensajesAutoModal = Permiso.ConsultarMensajes
		//this.permisoGrafica = Permiso.v
		this.permisoGaleriaAutoModal = Permiso.VisualizarGaleria;
		this.permisoVisualizarVideos = Permiso.VisualizarVideos;
	}

	public get Permiso() {
		return Permiso;
	}

	mostrarOperador(imagenData) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.disableClose = true;
		dialogConfig.width = "30%";
		dialogConfig.closeOnNavigation = true;
		dialogConfig.hasBackdrop = false;
		dialogConfig.panelClass = 'custom-modalbox';
		this.dialog.open(PerfiloperadorComponent,{data:imagenData}).afterClosed().subscribe(()=>{
	
		})
	
		}

}
